import { useEffect } from 'react';
import { useMap } from 'react-map-gl';
import { regular_charger_pin, fast_charger_pin } from '../utility/icons';

const images = [{ name: 'charger', image: regular_charger_pin }, { name: 'fast_charger', image: fast_charger_pin }]

export default function MapImages() {
    const { current: map } = useMap()

    useEffect(() => {
        if (typeof map?.addImage === 'function') {
            images.map(image => map.loadImage(image.image, (error, img) => {
                try {
                    if (error) throw error
                    if (!map.hasImage(image.name)) map.addImage(image.name, img)
                } catch (error) {
                    console.log('MapImages error', { error })
                }
            }))
        }
    }, [map])

    return null
}